/* ------------------------------------------------------------------
 *  その他汎用的関数
--------------------------------------------------------------------- */
/* ------------------------------------------------------------------
related_story_listのスライダーをset
--------------------------------------------------------------------- */
function set_related_story_list_slider() {
  const $sliders = $(".jsSlider3");
  const refreshSliderPosition = ($slider) => {
    if (!$slider.hasClass("slick-initialized")) return;

    $slider.slick("setPosition");
  };

  $sliders.each(function () {
    const $slider = $(this);

    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick");
    }

    $slider.slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      adaptiveHeight: true,
    });

    window.requestAnimationFrame(() => {
      refreshSliderPosition($slider);
    });

    window.setTimeout(() => {
      refreshSliderPosition($slider);
    }, 120);
  });
}

/* ------------------------------------------------------------------
safari用 datalist
--------------------------------------------------------------------- */

function displayUserAddressMap(location_lat, location_lng) {
  const renderMap = function () {
    const lat = location_lat;
    const lng = location_lng;
    const MyLatLng = new google.maps.LatLng(lat, lng);
    const Options = {
      zoom: 15,
      center: MyLatLng,
      mapTypeId: "roadmap",
    };
    const map = new google.maps.Map(
      document.getElementById("jsGoogleMap"),
      Options
    );
    const _marker = new google.maps.Marker({
      position: MyLatLng,
      map,
    });
  };

  if (typeof google !== "undefined" && google.maps) {
    renderMap();
  } else if (window.googleMapsApiKey) {
    $.getScript(
      `https://maps.googleapis.com/maps/api/js?key=${window.googleMapsApiKey}&libraries=places&language=ja&region=JP`,
      renderMap
    );
  } else {
    console.error("Google Maps API key is not configured");
  }
}

function stickMenuBar(min_height_selector) {
  const $win = $(window);
  $win.on("load scroll", function () {
    const value = $(this).scrollTop();
    const offset = $(min_height_selector).offset();
    if (!offset) return;
    const min_height = offset.top;
    if (min_height < value) {
      $(".stickyMenu").addClass("is-show");
    } else {
      $(".stickyMenu").removeClass("is-show");
    }
  });
}

function stickyAd(min_height_selector, max_height_selector, max_ad_height) {
  const $win = $(window);
  $win.on("load scroll", function () {
    const value = $(this).scrollTop();
    const min_height = $(min_height_selector).offset().top;
    const max_height = $(max_height_selector).offset().top;
    const ad_height = max_ad_height + 20;
    const sticky_area = max_height - ad_height;
    if (min_height < value && sticky_area > value) {
      $(".stickyAd").addClass("is-sticky");
    } else {
      $(".stickyAd").removeClass("is-sticky");
    }
  });
}

/* ------------------------------------------------------------------
ページスクロールリンクの設置
--------------------------------------------------------------------- */
function scrollToTop(additional_offset = 0) {
  $("a[href^='#'].jsScroll").click(function () {
    const speed = 500;
    const href = $(this).attr("href");
    const target = $(href == "#" || href == "" ? "html" : href);
    const position = target.offset().top + additional_offset;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
}
/* ------------------------------------------------------------------
ブラウザがIEかどうかを判定
--------------------------------------------------------------------- */
function is_ie() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return (
    userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident") !== -1
  );
}

function sleep(waitSec, callbackFunc) {
  const waitMs = waitSec * 1000;
  const waitFunc = function () {
    if (callbackFunc) callbackFunc();
  };

  setTimeout(waitFunc, waitMs);
}

/* ------------------------------------------------------------------
隠したリストを表示させる
--------------------------------------------------------------------- */

function showHideData(click_elm, show_elm, rm_class) {
  $(document).on("click", click_elm, function () {
    $(document).find(show_elm).removeClass(rm_class);
    $(this).remove();
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export {
  set_related_story_list_slider,
  displayUserAddressMap,
  stickMenuBar,
  stickyAd,
  scrollToTop,
  is_ie,
  sleep,
  showHideData,
};
